import { createSelector } from 'reselect'

import { selectAppState } from 'src/core/store/selectors/selectAppState'

export const selectPublishingMode = createSelector(
  [selectAppState],
  ({ publishingMode }) => publishingMode
)
